module.exports = __webpack_public_path__ + "img/banner-text.ea8633fb.png";